import { KalturaClientOptions } from '@kaltura-ott/ott-client-types/api';

export const PERFORMANCE_FEATURE = {
  PERFORMANCE_PRELOAD_AFTER_LOAD: true,
  PERFORMANCE_LAST_WATCHED: true,
  PERFORMANCE_LOAD_ALL_DAY_IF_CURRENT_NOT_FOUND: true,
  PERFORMANCE_LOAD_RAIL_ADDITION_DATA: true,
  PERFORMANCE_RECORDS: true,
  PERFORMANCE_PRODUCT_PRICE_HERO_EPG: true,
  PERFORMANCE_CHUNK_SIZE_EPG_PROGRAM: 100,
  PERFORMANCE_FOLLOW_FIRST_PROGRAM_HERO: true,
};

export interface KuxConfig extends KalturaClientOptions {
  endpointUrl: string;
  ks?: string;
  language?: string;
  persistCachingTtl?: number;
  brandId: number;
  userId?: string;
  customerType?: string;
  isDebug?: boolean;
}

export let KuXConfig: (config: KuxConfig) => KuxConfig | string;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const loggerDev = (...args: any) => {
  console.log('TVPIL--', ...args);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const loggerProd = (...args: any) => {};

export let kuxLogger = loggerProd;

const doConfig = (config: KuxConfig) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (prop: any): KuxConfig | string => {
    if (prop) {
      // @ts-expect-error TODO Fix
      return config[prop];
    } else {
      return config;
    }
  };
};

export function kuxSetConfig(config: KuxConfig): void {
  if (config.isDebug) {
    kuxLogger = loggerDev;
  }
  KuXConfig = doConfig(config);
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getConfig = (f: any) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (x: any) => f(x);
};

export function kuxUpdateConfig(config: Partial<KuxConfig>): void {
  const _conf = getConfig(KuXConfig)(null);
  kuxSetConfig(Object.assign(_conf, config));
}
